import { Component } from '@angular/core';

@Component({
  selector: 'search-icon',
  templateUrl: 'search-icon.html'
})
export class SearchIconComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/icons/search-icon/search-icon.ts